// extracted by mini-css-extract-plugin
module.exports = {"toc":"toc_toc__2u1rY","bgImg":"toc_bgImg__98Ipk","content":"toc_content__3GUCx"};